// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as V2$Linear from "./V2.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";

function fromVertices(vertices) {
  return Belt_Array.zip(vertices, LumiArray.roll(vertices, -1)).map(param => ({
    from: param[0],
    to: param[1]
  }));
}

function jsonCodec(elementCodec) {
  return Jzon.object2(param => [
    param.from,
    param.to
  ], param => ({
    TAG: "Ok",
    _0: {
      from: param[0],
      to: param[1]
    }
  }), Jzon.field("from", V2$Linear.jsonCodec(elementCodec)), Jzon.field("to", V2$Linear.jsonCodec(elementCodec)));
}

export {
  fromVertices,
  jsonCodec,
}
/* No side effect */
